const NotFoundPage = () => {
  return (
    <div className="centered">
      <p>not found </p>
    </div>
  );
};

export default NotFoundPage;
